import { render, staticRenderFns } from "./StructuredAddress.vue?vue&type=template&id=c34c1f8a&scoped=true"
import script from "./StructuredAddress.vue?vue&type=script&lang=ts"
export * from "./StructuredAddress.vue?vue&type=script&lang=ts"
import style0 from "./StructuredAddress.vue?vue&type=style&index=0&id=c34c1f8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34c1f8a",
  null
  
)

export default component.exports